<template>
  <a-modal
    centered
    title="宾客档案"
    v-model="visible"
    width="80%"
    okText="确认"
    @ok="onCancel"
    @cancel="onCancel"
    :maskClosable="false"
    :destroyOnClose="true"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="spinning">
      <div class="content">
        <a-tabs>
          <a-tab-pane tab="基本信息" key="1" class="guest-info">
            <h2 class="title">基本信息</h2>
            <a-row>
              <a-col span="6">
                <label>姓名：</label>{{ currentItem.Name }}
              </a-col>
              <a-col span="6">
                <label>联系方式：</label>{{ currentItem.Phone }}
              </a-col>
              <a-col span="6">
                <label>证件类型：</label
                >{{ currentItem.IdTypeName ? currentItem.IdTypeName : "无" }}
              </a-col>
              <a-col span="6">
                <label>证件号码：</label
                >{{ currentItem.IdNumber ? currentItem.IdNumber : "无" }}
              </a-col>
              <a-col span="6">
                <label>出生日期：</label
                >{{
                  currentItem.Birthday
                    ? moment(currentItem.Birthday).format("YYYY-MM-DD")
                    : ""
                }}
              </a-col>
              <a-col span="6">
                <label>性别：</label>{{ currentItem.Sex }}
              </a-col>
              <a-col span="6">
                <label>国家：</label>{{ currentItem.Country }}
              </a-col>
              <a-col span="24">
                <label>备注：</label
                >{{ currentItem.Remark ? currentItem.Remark : "无" }}
              </a-col>
            </a-row>
            <h2 class="title">消费信息</h2>
            <a-row>
              <a-col span="6">
                <label>总消费：</label>{{ currentItem.TotalPrice }}
              </a-col>
              <a-col span="6">
                <label>房费:</label>{{ currentItem.RoomPrice }}
              </a-col>
              <a-col span="6">
                <label>其他消费：</label>{{ currentItem.OtherPrice }}
              </a-col>
              <a-col span="6">
                <label>开票总额：</label>{{ currentItem.MakeOutPrice }}
              </a-col>
              <a-col span="24">
                <label>喜好：</label
                >{{ currentItem.Like ? currentItem.Like : "无" }}
              </a-col>
            </a-row>
          </a-tab-pane>
          <a-tab-pane tab="客人消费记录" key="2">
            <DataGrid
              :columns="consume.colums"
              ref="consumeDataGrid"
              api="Guest_ConsumeInfo"
              v-model="consume.data"
              :params="consume.params"
              :pagination="true"
              :props="props"
              bordered
            ></DataGrid>
          </a-tab-pane>
          <!-- <a-tab-pane tab="日志" key="3" :forceRender="true">
            <DataGrid
              :colums="log.colums"
              ref="logDataGrid"
              api="Guest_LogList"
              v-model="log.data"
              :params="log.params"
              :pagination="true"
              bordered
            ></DataGrid>
          </a-tab-pane> -->
        </a-tabs>
      </div>
    </a-spin>
  </a-modal>
</template>
<script>
import { cache } from "@/utils/common.js";
import DataGrid from "@/components/dataGrid/DataGrid";
import {
  OrderDetailModal,
  TeamOrderDetailModal
} from "@/views/orderManage/funtion.js";
// import dataForm from "@/components/dataForm/DataForm";
import moment from "moment";
moment.locale("zh-cn");
export default {
  name: "GuestDetail",
  components: {
    // dataForm,
    DataGrid
  },
  data() {
    return {
      confirmLoading: false,
      spinning: false,
      visible: false,
      user: null,
      currentItem: {},

      consume: {
        colums: [
          {
            title: "序号",
            width: "4%", //宽度
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          },
          {
            title: "订单号",
            width: "10%",
            dataIndex: "No",
            customRender: (text, record) => {
              if (text) {
                const orderDetail = {
                  click: () => {
                    this.orderDetail(record);
                  }
                };
                return (
                  <a-button type="link" {...{ on: orderDetail }}>
                    {text}
                  </a-button>
                );
              }
            }
          },
          {
            title: "房号",
            width: "7%",
            dataIndex: "RoomNo",
            customRender: text => {
              return <span style="word-break: break-all;">{text}</span>;
            }
          },
          {
            title: "入住日期",
            width: "8%",
            dataIndex: "CheckInDate"
          },
          {
            title: "离店日期",
            width: "7%",
            dataIndex: "CheckOutDate"
          },
          {
            title: "房价",
            width: "7%",
            dataIndex: "RoomPrice"
          },
          {
            title: "客户",
            width: "10%",
            dataIndex: "CustomerName"
          },
          {
            title: "渠道",
            width: "7%",
            dataIndex: "ChanelName"
          },
          {
            title: "房晚",
            width: "7%",
            dataIndex: "RoomNight"
          },
          {
            title: "总消费",
            width: "7%",
            dataIndex: "TotalAmount"
          },
          {
            title: "房费",
            width: "7%",
            align: "right",
            dataIndex: "RoomAmount"
          },
          {
            title: "其他消费",
            align: "right",
            width: "7%",
            dataIndex: "OtherAmount"
          },
          {
            title: "备注",
            dataIndex: "Remark"
          }
        ],
        data: [],
        params: {}
      },
      log: {
        colums: [],
        data: [],
        params: {}
      },
      props: {},
      defaultItem: {}
    };
  },
  created() {
    this.user = cache.get("user");
    this.props = {
      scroll: {
        x: 1400,
        y: window.document.body.clientHeight - 300
      }
    };
    this.$post("Room_GetDefaultTime", {}).then(res => {
      res.Data.SystemConstList.forEach(item => {
        this.defaultItem[item.Code] = item.Value;
      });
    });
  },
  mounted() {},
  methods: {
    orderDetail(record) {
      if (this.defaultItem.PlusHotelOrderModel == 1) {
        TeamOrderDetailModal({
          orderId: record.Id,
          showBtn: false
        });
      } else {
        OrderDetailModal({
          orderId: record.Id,
          showBtn: false
        });
      }
    },
    show(record) {
      this.currentItem = record;
      this.consume.params = {
        Id: record.Id
      };
      // this.spinning = true;
      this.visible = true;
    },
    onCancel() {
      this.visible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.guest-info {
  color: #000;
  .ant-row {
    margin-bottom: 30px;
    & > div {
      margin-top: 10px;
      font-size: 14px;
      label {
        display: inline-block;
        width: 100px;
        text-align: right;
        padding: 0 5px;
        color: #666;
      }
    }
  }
}
</style>
